import * as React from "react"

export const NoResultIcon = () => {
  return (
    <svg width="180" height="151" viewBox="0 0 180 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="180" height="150" transform="translate(0 0.5)" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M129.377 8.77758C105.212 4.83347 107.676 44.3139 75.5222 38.9102C42.6346 33.3831 32.8051 72.3733 42.6346 93.9099C53.251 117.171 121.23 129.675 145.55 112.528C172.922 93.229 174.717 16.1778 129.377 8.77758Z"
        fill="#E3EBF5"
      />
      <path
        d="M30.5 58H148.5V131.5C148.5 132.881 147.381 134 146 134H34C32.067 134 30.5 132.433 30.5 130.5V58Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M30.5 48.5C30.5 47.1193 31.6193 46 33 46H146C147.381 46 148.5 47.1193 148.5 48.5V59H30.5V48.5Z"
        fill="white"
        stroke="black"
      />
      <circle cx="37.5" cy="53" r="2" stroke="black" />
      <circle cx="44.5" cy="53" r="2" stroke="black" />
      <circle cx="51.5" cy="53" r="2" stroke="black" />
      <path
        d="M12.9554 124.5H53.5179C57.2054 124.5 63 121.37 63 114.065C63 107.387 58.2589 103.63 55.0982 103.63C55.0982 96.8478 50.8839 88.5 40.3482 88.5C29.8125 88.5 27.1786 95.8043 27.1786 99.4565C27.1786 97.8913 25.0714 95.8043 20.3304 95.8043C14.5357 95.8043 12.9554 101.543 12.9554 104.674C8.74107 104.674 4 107.283 4 114.065C4 121.578 9.26786 124.5 12.9554 124.5Z"
        fill="#E3EBF5"
      />
      <path
        d="M68.343 28.2485C66.0783 21.549 75.5314 19.786 81.9496 15.2022C90.6784 7.44489 93.5002 6.89666 95.8107 11.1279C98.1213 15.3591 97.3533 24.0172 90.9351 29.3063C84.5169 34.5953 71.6804 38.1213 68.343 28.2485Z"
        fill="#E3EBF5"
      />
      <path
        d="M95.6358 85.1359C98.7156 82.0561 102.811 80.3602 107.167 80.3602C111.522 80.3602 115.617 82.0563 118.698 85.1359C124.565 91.0026 125.013 100.263 120.053 106.654L129.539 116.141C130.34 116.941 130.34 118.239 129.539 119.039C129.139 119.44 128.614 119.64 128.09 119.64C127.566 119.64 127.041 119.44 126.641 119.039L117.154 109.553C114.308 111.768 110.83 112.972 107.166 112.972C102.809 112.972 98.7159 111.276 95.636 108.197C92.5562 105.117 90.8603 101.022 90.8603 96.6656C90.8603 92.311 92.5563 88.2159 95.636 85.136L95.6358 85.1359ZM98.5347 105.3C100.839 107.604 103.905 108.874 107.166 108.874C110.426 108.874 113.492 107.604 115.798 105.3C120.558 100.54 120.558 92.7964 115.798 88.0367C113.492 85.7304 110.426 84.4604 107.166 84.4604C103.905 84.4604 100.839 85.7304 98.533 88.0367C96.2268 90.3413 94.9567 93.4068 94.9567 96.6676C94.9599 99.9267 96.2284 102.994 98.5346 105.3L98.5347 105.3Z"
        fill="#3E92D2"
      />
      <rect width="19.7485" height="7.912" transform="matrix(-1 0 0 1 130.749 92.5)" fill="white" />
      <path
        d="M116.936 96.444C116.936 95.388 116.048 94.5 114.968 94.5C113.888 94.5 113 95.388 113 96.444C113 97.524 113.888 98.412 114.968 98.412C116.048 98.412 116.936 97.524 116.936 96.444Z"
        fill="#3E92D2"
      />
      <path
        d="M122.842 96.444C122.842 95.388 121.954 94.5 120.874 94.5C119.794 94.5 118.906 95.388 118.906 96.444C118.906 97.524 119.794 98.412 120.874 98.412C121.954 98.412 122.842 97.524 122.842 96.444Z"
        fill="#3E92D2"
      />
      <path
        d="M128.749 96.444C128.749 95.388 127.861 94.5 126.781 94.5C125.701 94.5 124.812 95.388 124.812 96.444C124.812 97.524 125.701 98.412 126.781 98.412C127.861 98.412 128.749 97.524 128.749 96.444Z"
        fill="#3E92D2"
      />
    </svg>
  )
}
